var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-layout",
    { attrs: { wrap: "", "px-0": "" } },
    [
      _c(
        "v-flex",
        { staticClass: "form-section", attrs: { "pl-4": "", xs12: "" } },
        [
          _c(
            "v-layout",
            { attrs: { row: "" } },
            [
              _c(
                "v-flex",
                { attrs: { "pl-0": "", "pr-4": "", xs12: "" } },
                [
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.lblSetting.amAttributeType
                      }
                    },
                    [
                      _c("v-select", {
                        attrs: {
                          required: "",
                          rules: _vm.dtRules.type,
                          items: _vm.attributeTypes,
                          "item-value": "id",
                          "item-text": "name",
                          disabled: _vm.isUpdate,
                          solo: ""
                        },
                        model: {
                          value: _vm.fkAttributeType,
                          callback: function($$v) {
                            _vm.fkAttributeType = $$v
                          },
                          expression: "fkAttributeType"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "base-control-label-vertical",
                    {
                      attrs: {
                        required: "",
                        label: _vm.lblSetting.amCharPbName
                      }
                    },
                    [
                      _c("v-text-field", {
                        attrs: {
                          counter: 80,
                          maxlength: 80,
                          required: "",
                          rules: _vm.dtRules.name,
                          solo: "",
                          placeholder: "ex: Kilométrage"
                        },
                        model: {
                          value: _vm.name,
                          callback: function($$v) {
                            _vm.name = $$v
                          },
                          expression: "name"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.fkAttributeType == 1
                    ? _c(
                        "base-control-label-vertical",
                        { attrs: { label: _vm.lblSetting.amAttributeUnit } },
                        [
                          _c("v-text-field", {
                            attrs: {
                              counter: 25,
                              maxlength: 25,
                              solo: "",
                              placeholder: "ex: km"
                            },
                            model: {
                              value: _vm.unit,
                              callback: function($$v) {
                                _vm.unit = $$v
                              },
                              expression: "unit"
                            }
                          })
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.fkAttributeType == 1 || _vm.fkAttributeType == 4) &
                  (this.$route.name !==
                    "agency_management_attachment_type_details")
                    ? _c("v-checkbox", {
                        staticClass: "px-3",
                        attrs: {
                          label: _vm.$t(
                            _vm.lblSetting.amUseAttributeInMaintenance
                          ),
                          color: "primary"
                        },
                        model: {
                          value: _vm.used_by_maintenance,
                          callback: function($$v) {
                            _vm.used_by_maintenance = $$v
                          },
                          expression: "used_by_maintenance"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  (_vm.fkAttributeType == 4) &
                  (this.$route.name ===
                    "agency_management_attachment_type_details")
                    ? _c("v-checkbox", {
                        staticClass: "px-3",
                        attrs: {
                          label: _vm.$t(_vm.lblSetting.amUseAttributeInAlert),
                          color: "primary"
                        },
                        model: {
                          value: _vm.used_by_alert,
                          callback: function($$v) {
                            _vm.used_by_alert = $$v
                          },
                          expression: "used_by_alert"
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "v-scroll-y-transition",
                    [
                      _vm.fkAttributeType == 4 && _vm.used_by_alert
                        ? _c(
                            "base-control-label-vertical",
                            {
                              attrs: {
                                required: "",
                                label: _vm.lblSetting.amAlertBefore
                              }
                            },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  type: "number",
                                  rules: _vm.dtRules.alertPreDelay,
                                  suffix: "Jour(s)",
                                  solo: ""
                                },
                                model: {
                                  value: _vm.alert_pre_delay,
                                  callback: function($$v) {
                                    _vm.alert_pre_delay = _vm._n($$v)
                                  },
                                  expression: "alert_pre_delay"
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4194d626", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4194d626","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/containers/profile/components/am-attribute-modal-vertical/template.html
// module id = null
// module chunks = 